import React from 'react';
import type { MainLayoutProps } from '@/design-system/Templates/MainLayout/MainLayout.types';
import { cn } from '@/utils/className';

const MainLayout: React.FC<MainLayoutProps> = ({
  children,
  header,
  sidebar = "",
  footer,
  className = "",
  sidebarPosition = 'left',
  stickySidebar = true,
  fullWidth = false,
  sectionClassNames = {},
  topBanner = "",
}) => { 
  const layoutContent = (
    <div className='flex'>
      {sidebar && sidebarPosition === 'left' && (
        <aside
          className={cn(
            'w-64 flex-shrink-0 border-border bg-card',
            stickySidebar ? 'sticky top-0 h-screen border-r' : '',
            sectionClassNames.sidebar
          )}
        >
          {sidebar}
        </aside>
      )}

      <main className={cn('flex-1 min-w-0', sectionClassNames.main)}>
        {topBanner && (
          <>
            {topBanner}
          </>
        )}
        <div className={cn(fullWidth ? 'px-0' : ' ')}>
          {children}
        </div>
      </main>

      {sidebar && sidebarPosition === 'right' && (
        <aside
          className={cn(
            'w-64 flex-shrink-0 border-border bg-card',
            stickySidebar ? 'sticky top-0 h-screen border-l' : '',
            sectionClassNames.sidebar
          )}
        >
          {sidebar}
        </aside>
      )}
    </div>
  );

  return (
    <div
      className={cn(
        'min-h-screen bg-background',
        header ? 'pt-[var(--header-height-mobile)] lg:pt-[var(--header-height-desktop)]' : "",
        className
      )}
    >
      {header && (
        <>
          {header}
        </>
      )}

      {layoutContent}

      {footer && (
        <footer
        >
          {footer}
        </footer>
      )}
    </div>
  );
};

export default MainLayout;
